// extracted by mini-css-extract-plugin
export default {"wrapper":"TeamsOfService_wrapper_kfz5b","linkParagraph":"TeamsOfService_linkParagraph_lGg0j"};